import  "./alunos.css"
import { useEffect, useState } from "react"
import AlunoAdd from "./AlunosAdd"
import { filtro, getItens } from "../../../firebase/CRUD"
import { useAuth } from "../../../hooks/AuthContext"
import AlunoFicha from "./AlunoFicha"
import ContainerLista from "../../layout/ContainerLista/ContainerLista"

export default function Alunos(){
    const {usuario} = useAuth()
    const [Alunos,setAlunos] = useState([])
    const [cadastramento,setCadastramento] = useState(false)
    const [carregando,setCarregando] = useState(true)
    useEffect(()=>{
        const dados = (dt)=>{
            if(dt){
                console.log(dt)
                setAlunos(dt)
            }
            setCarregando(false)
        }
            if(usuario.perfil === 'adm')
                return getItens("alunos",dados,usuario.idEscola)
            if(usuario.perfil === 'professor')
                filtro("alunos","turma","==",usuario.turma,dados,usuario.idEscola)
        
    },[])

    const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }

    return(
        <div style={{width:'100%'}}>
            <ContainerLista itensLista={Alunos} pagina={'Alunos'} cadastramento={ativarCadastramento} carregando={carregando}>
                {Alunos.length > 0 && 
                    Alunos.map((item)=>
                        <AlunoFicha key={item.id} aluno={item}/>
                    )
                }
            </ContainerLista>
            {cadastramento && <AlunoAdd cadastramento={desativarCadastramento}/>}
        </div>
    )
}